import { connect } from 'react-redux';
import NotFound from "./NotFound.jsx";
import { withRouter } from 'react-router-dom';

const mapStateToProps = (state) => {
    return {
        loggedIn: state.sesion.loggedIn
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotFound));


// WEBPACK FOOTER //
// ./Portico/App/Screens/Errores/NotFoundContainer.jsx